import { React, useState, useEffect, useRef, use } from "react";
import {
    Stack,
    InputLabel,
    MenuItem,
    FormControl,
    Select,
    TextField,
    Tooltip,
    Box,
    colors,
    Typography,
    Autocomplete,
} from "@mui/material";

import { DatePicker } from 'rsuite';
import "rsuite/dist/rsuite.css";
import { getCorporationsByMgntGrp, getManagementGroupsList } from "../API/nimbleAPI";
import { getCorporationLabel, Loader } from "../HelperFunctions/HelperFunctions";
import FlashReportCorpDialog from "./FlashReportCorpDialog";
import { useLoaderData } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import addDays from 'date-fns/addDays';

const CustomeDetails = ({ formik, handleData, onClose, defaultDetails }) => {

    const { token, corpId, UID } = useLoaderData();
    const [loading, setLoading] = useState(false);
    const [mngGroups, setMngGroups] = useState([]);
    const [corpDialog, setCorpDialog] = useState(false);
    const [corporationCount, setCorporationCount] = useState(false);

    useEffect(() => {
        managementGroups()
    }, []);

    useEffect(() => {
        if (!defaultDetails && corpId !== "000000000000000000000000000000000000") {
            formik.setFieldValue("details.corporation", [corpId]);
        }
        else if (!defaultDetails && corpId === "000000000000000000000000000000000000") {
            fetchCorporations("ALL")
        }
        else if (defaultDetails) {
            fetchCorporations(formik.values.details.management_groups.ValueCode, true)
        }
    }, []);


    const fetchCorporations = async (valueCode, getList = false) => {
        setLoading(true);
        try {
            const data = await getCorporationsByMgntGrp(valueCode);
            const corporationIds = data.map(item => item.CorporationID);
            if (getList) {
                setCorporationCount(corporationIds.length);
                setLoading(false);
                return;
            }
            formik.setFieldValue("details.corporation", corporationIds);
            setCorporationCount(corporationIds.length)
        } catch (error) {
            enqueueSnackbar("Error while getting Corporations", { variant: "error" })
        } finally {
            setLoading(false);
        }
    };



    const managementGroups = async () => {
        try {
            const groups = await getManagementGroupsList();
            if (groups.status == 200) {
                const grpData = await groups.json()
                setMngGroups(grpData);
            } else {
                enqueueSnackbar("Error while getting Management ", { variant: "error" })
                onClose()
            }


        } catch (error) {
            enqueueSnackbar("Error while getting Management List", { variant: "error" })
        }
    };

    const predefinedBottomRanges = [
        {
            label: 'today',
            value: new Date(),
            // placement:"left"
        },
        {
            label: 'yesterday',
            value: addDays(new Date(), -1),
            // placement:"left"
        }
    ];


    return (

        <>
            <Stack gap={4} mt={2} pr={5} >
                <Autocomplete
                    size="small"
                    options={mngGroups}
                    getOptionLabel={(option) => option.DisplayText}
                    isOptionEqualToValue={(option, value) => option?.ValueCode === value?.ValueCode}
                    value={formik.values.details.management_groups || null}
                    disableClearable
                    onChange={(event, newValue) => {
                        if (
                            newValue &&
                            ["ALL", "PropertyType", "BrandName", "Portfolio", "Region", "ServiceType"].includes(newValue.ValueCode)
                        ) {

                            formik.setFieldValue("details.management_groups", {
                                ValueCode: "ALL",
                                DisplayText: "--ALL--",
                            });
                            fetchCorporations("ALL")
                        } else {
                            formik.setFieldValue("details.management_groups", newValue);
                        }
                        formik.setFieldValue("details.corporation", []);
                        setCorporationCount(false)
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Management Groups"
                            inputProps={{ ...params.inputProps, readOnly: true }}
                            InputProps={{
                                ...params.InputProps,
                                sx: { fontSize: "12px", fontWeight: 500, },
                            }}
                            InputLabelProps={{
                                sx: { fontSize: "12px" },
                            }}
                        />
                    )}
                    renderOption={(props, option) => (
                        <li {...props} key={option.ValueCode} style={{ fontSize: "13px", fontWeight: 500, }}>
                            {option.DisplayText}
                        </li>
                    )}
                />


                {typeof handleData === "function" &&
                    <Tooltip title="select corporation" arrow>
                        <TextField
                            sx={{
                                mt: 1,
                                // minWidth: 300,
                                backgroundColor: "transparent",
                                // cursor: "pointer",
                                "& .MuiOutlinedInput-root": {
                                    backgroundColor: "transparent",
                                    maxHeight: "33px",
                                    fontSize: "13px",
                                    bgcolor: "#f5f5f5",
                                    fontWeight: 500,
                                    cursor: "pointer",
                                },
                                "& .MuiOutlinedInput-input": {
                                    cursor: "pointer",
                                }

                            }}
                            size="small"
                            label="Corporation"
                            onClick={() => setCorpDialog(true)}
                            name="details.corporation"
                            value={
                                formik.values.details.corporation.length === corporationCount && corporationCount > 0 ? "All_corporation(s)selected"
                                    :
                                    formik.values.details.corporation.length > 9
                                        ? `${formik.values.details.corporation.length}_corporation(s)selected`
                                        : formik.values.details.corporation.length > 0
                                            ? `0${formik.values.details.corporation.length}_corporation(s)selected`
                                            : "00_corporation(s)selected"
                            }
                            InputProps={{ readOnly: true }}

                        />
                    </Tooltip>
                }

                <Stack gap={0} >
                    <Typography style={{ fontSize: "11px", fontWeight: 400, color: "#7b7b7b", marginLeft: 10, display: "block" }}>
                        Sale Date
                    </Typography>
                    <DatePicker
                        oneTap
                        placeholder="Select Date"
                        container={() => document.querySelector('#dialog-content')}
                        format="MM/dd/yyyy"
                        ranges={predefinedBottomRanges}
                        value={formik.values.details.date ? new Date(formik.values.details.date) : null}
                        onChange={(value) => {
                            if (value) {
                                const istDate = new Date(
                                    value.getTime() - value.getTimezoneOffset() * 60000
                                ).toISOString();
                                formik.setFieldValue("details.date", istDate);
                            } else {
                                formik.setFieldValue("details.date", null);
                            }
                        }}
                    />
                </Stack>




            </Stack>
            {corpDialog &&

                <FlashReportCorpDialog
                    open={corpDialog}
                    onClose={() => setCorpDialog(false)}
                    formik={formik}
                    managementGroups={mngGroups}
                    corpCount={setCorporationCount}

                />

            }
            {loading && <Loader loading={loading} />}
        </>

    );
};

export default CustomeDetails;